/**
 * @fileoverview This file contains constants used throughout the project.
 *
 * @module Constants
 *
 * @requires three
 * @exports DEFAULT_MIN_POLAR_ANGLE
 * @exports DEFAULT_MAX_POLAR_ANGLE
 * @exports DEFAULT_MIN_AZIMUTH_ANGLE
 * @exports DEFAULT_MAX_AZIMUTH_ANGLE
 * @exports DEFAULT_HOTSPOT_IMAGE
 * @exports TONE_MAPPING_TYPES
 * @exports TONE_MAPPING_TYPES.linear
 * @exports TONE_MAPPING_TYPES.reinhard
 * @exports TONE_MAPPING_TYPES.aces
 * @exports TONE_MAPPING_TYPES.cineon
 * @exports TONE_MAPPING_TYPES.no
 * @exports OUTPUT_ENCODING_MAP
 * @exports OUTPUT_ENCODING_MAP.sRGBEncoding
 *
 */
import * as THREE from 'three';

export const DEFAULT_MIN_POLAR_ANGLE = 40;
export const DEFAULT_MAX_POLAR_ANGLE = 120;
export const DEFAULT_MIN_AZIMUTH_ANGLE = -Infinity;
export const DEFAULT_MAX_AZIMUTH_ANGLE = Infinity;
export const DEFAULT_HOTSPOT_IMAGE =
	'https://cdn.obsess-vr.com/default_icons/dot_with_ring_white.svg';

/**
 * Tone mapping types
 * @property TONE_MAPPING_TYPES
 *
 * @type {Object}
 */
export const TONE_MAPPING_TYPES = {
	linear: THREE.LinearToneMapping,
	reinhard: THREE.ReinhardToneMapping,
	aces: THREE.ACESFilmicToneMapping,
	cineon: THREE.CineonToneMapping,
	no: THREE.NoToneMapping,
};

/**
 * Supported output encodings map
 * @property OUTPUT_ENCODING_MAP
 *
 * @type {{sRGBEncoding: (number|*)}}
 *
 * ** Maps the new THREE.js encoding types to the old ones since those are the ones supported from AVA **
 */
export const OUTPUT_ENCODING_MAP = {
	sRGBEncoding: THREE.SRGBColorSpace,
};

export const COLOR_SPACE_MAP = {
	srgb: THREE.SRGBColorSpace,
	"srgb-linear": THREE.LinearSRGBColorSpace,
};

export const DIST_FROM_HOTSPOT = 3;

export const CONTROL_MODES = {
	AVATAR_NAVIGATION: 'avatar_navigation',
	CLICK_NAVIGATION: 'click_navigation',
	FIRST_PERSON: 'first_person_navigation',
	SCROLL: 'scroll',
};
